module.exports = __webpack_public_path__ + "img/land.9835cdb1.svg";